import React, { useState, useEffect } from 'react';
import ExamMetricsUserListItem from './ExamMetricsUserListItem';
import { useNavigate, useParams } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';

import ExamMetricsKpis from './ExamMetricsKpis';
import { useClient } from 'jsonapi-react';
import { EmptyState } from '@/components/custom/empty-state';
import { useTranslation } from 'react-i18next';
import { Loader } from '@/components/custom/loader';
import toast from 'react-hot-toast';
import { WidgetWrapper } from '@/components/custom/widget';
import { DashboardContent } from '@/layouts/dashboard';
import { Table, TableBody, TableHeaderWrapper } from '@/components/ui/table';

export function AdminMetrics(props) {
  const { uri } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const client = useClient();
  const examId = useParams().id;
  const [examStudents, setExamEstudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exam, setExam] = useState([]);

  const listItem = examStudents.map(item => {
    return (
      <ExamMetricsUserListItem
        key={item.id}
        examStudent={item}
        exam={exam}
      />
    );
  });

  const getExamStudents = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`question_books_users/reports?filter[question_book_id]=${examId}`);
    if (error) {
      toast.error('Erro ao carregar dados da prova');
    } else {
      setExamEstudents(data);
    }
    setLoading(false);
  };

  const getExam = async () => {
    try {
      const { data } = await client.fetch(`question_books/${examId}`);
      setExam(data);
    } catch {
      toast.error(t('toast.errorGetExams'));
    }
  };

  useEffect(() => {
    getExam();
    getExamStudents();
  }, []);

  const TABLE_HEAD = [
    { label: t('exams.thParticipant'), width: 200 },
    { label: t('exams.thResolutionDate'), width: 120 },
    { label: t('exams.thCorrectedBy'), width: 120 },
    { label: t('exams.thScore'), width: 80 },
    { label: t('exams.thCorrectionStatus'), width: 150 },
    ...(exam.visibility !== 'open' ? [{ label: t('exams.thResults'), width: 140 }] : []),
    { label: t('exams.thActions'), width: 190 }
  ];

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: '/avaliacoes/resultados',
        name: 'Resultados',
        isActive: false
      },
      {
        route: uri,
        name: exam?.title,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      {exam && !loading && examStudents.length > 0 && (
        <ExamMetricsKpis
          currentExam={exam}
          examStudents={examStudents}
        />
      )}

      {loading && <Loader />}

      {examStudents.length === 0 && !loading && (
        <EmptyState
          type="data"
          title={t('emptyState.noStudentAnswered')}
          text={t('emptyState.noAnyResponses')}
        />
      )}

      {examStudents.length > 0 && !loading && (
        <Table className="min-w-[1300px] animate-fade-in">
          <TableHeaderWrapper tableHead={TABLE_HEAD} />

          <TableBody>{listItem}</TableBody>
        </Table>
      )}
    </DashboardContent>
  );
}
